import { AppActivity } from './App-activity';
import { AppLegacy } from './App-legacy';
import { getStoredOrgUrlParams, log } from './lib/core';

export const isActivity = !!getStoredOrgUrlParams().activity;

log.info('Application Started');

export default isActivity ? AppActivity : AppLegacy;
